import MineDamageLogic from "../../../logic/MineDamageLogic";
import Totals from "../../crew/Totals";
import Values from "../../value/Values";
import ClassicUpgrade from "./ClassicUpgrade";
import { CountToPurchase } from "./CountToPurchase";
import UpgradeCollection from "../UpgradeCollection";

export default class ClassicUpgradeCollection extends UpgradeCollection {
    constructor() {
        super();

        /**
         * @type {number}
         */
        this.countToPurchase = CountToPurchase.purchaseOne;
    }

    /**
     * @param {number} countToPurchase 
     */
    setCountToPurchase(countToPurchase) {
        if (this.countToPurchase === countToPurchase) {
            return;
        }

        this.countToPurchase = countToPurchase;

        // update all the upgrades
        for (let i = 0; i < this.upgrades.length; i++) {
            this.upgrades[i].countToPurchase = countToPurchase;
        }
    }

    /**
     * @abstract
     * @param {Totals} totals 
     * @param {Values} values
     * @param {MineDamageLogic} mineDamageLogic
     */
    initializeUpgrades(totals, values, mineDamageLogic) {
    }

    /**
     * @param {string} id 
     * @returns {ClassicUpgrade}
     */
    findById(id) {
        for (let i = 0; i < this.upgrades.length; i++) {
            const upgrade = this.upgrades[i];
            if (upgrade.id === id) {
                return upgrade;
            }
        }

        return null;
    }

    ////////////////////////////////////
    // GameModel
    ////////////////////////////////////

    /**
     * @override
     */
    resetFull() {
        // Do not call super! that will remove all the pick upgrades.

        for (let i = 0; i < this.upgrades.length; i++) {
            this.upgrades[i].resetUpgrade();
        }
    }

    // /**
    //  * @override
    //  */
    // resetForPrestige() {
    //     this.resetFull();
    // }

}